<div class="form-dialog">
  <h1>Estimate*
    <div (click)="showing_hints=!showing_hints">
      @if (showing_hints) {
        Hide hints
      }
      @if (!showing_hints) {
        Show hints
      }
    </div>
  </h1>
  <mat-dialog-content>
    <mat-tab-group [disableRipple]="true" style="min-width:800px;">
      <mat-tab label="Basic">
        <form class="form-section column">
          @if (estimate) {
            <div class="row">
              <div class="select-search" style="width:100%;">
                <select-search (selectChange)="estimateTypeSelected()"
                  [(value)]="selectedEstimateType"
                  [data]="estimateTypes"
                  [disabled]="estimate && estimate.hasOwnProperty('id')"
                  [label]="'Estimate Type'"
                  >
                </select-search>
              </div>
              <div class="select-search" style="width:100%;">
                <select-search-component [label]="'Series'"
                  [api_model]="'series_light'"
                  [(value)]="selectedSeries"
                  (selectionChange)="selectedSeries=$event.value;seriesSelected()"
                  [disabled]="estimate.hasOwnProperty('id')"
                  [classes]="'fill'"
                  >
                </select-search-component>
              </div>
            </div>
            <div class="row">
              <mat-form-field>
                <mat-label>Name*</mat-label>
                <input (change)="nameChanged()"
                  [(ngModel)]="estimate.attributes.name"
                  matInput
                  name="name">
              </mat-form-field>
              <mat-form-field>
                <mat-label>Description</mat-label>
                <input (change)="descriptionChanged()"
                  [(ngModel)]="estimate.attributes.description"
                  matInput
                  name="description"/>
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field>
                <mat-label>Fill Method</mat-label>
                @if (fillMethods.length > 0) {
                  <mat-select
                    (selectionChange)="fillMethodChange()"
                    [(ngModel)]="estimate.attributes.fill_method"
                    name="fillMethod">
                    @for (fillMethod of fillMethods; track fillMethod) {
                      <mat-option [title]="seriesData.fill_methods[fillMethod]"
                        [value]="fillMethod"
                      >{{fillMethod}}</mat-option>
                    }
                  </mat-select>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Sample Period</mat-label>
                @if (samplePeriods.length > 0) {
                  <mat-select (selectionChange)="samplePeriodChanged()"
                    [(ngModel)]="estimate.attributes.sample_period"
                    name="samplePeriod">
                    @for (samplePeriod of samplePeriods; track samplePeriod) {
                      <mat-option
                      [value]="samplePeriod">{{samplePeriod | titlecase | removeUnderscore}}</mat-option>
                    }
                  </mat-select>
                }
              </mat-form-field>
              <mat-form-field>
                <mat-label>Aggregation Type</mat-label>
                @if (aggregationTypes.length > 0) {
                  <mat-select (selectionChange)="aggregationTypeChanged()"
                    [(ngModel)]="estimate.attributes.aggregation"
                    name="aggregationType">
                    @for (aggregationType of aggregationTypes; track aggregationType) {
                      <mat-option
                        [title]="seriesData.aggregation_definitions[aggregationType]"
                      [value]="aggregationType">{{aggregationType | titlecase| removeUnderscore}}</mat-option>
                    }
                  </mat-select>
                }
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field style="max-width:150px ">
                <mat-label>Variance favourability</mat-label>
                <mat-select [(value)]="estimate.attributes.positive_variance"
                  title="Defines the favourability of a variance between target (estimate)  and actual values">
                  <mat-option [value]="true"
                    title="A positive difference between actual and target (estimate) values is favourable">Positive
                    variance
                  </mat-option>
                  <mat-option [value]="false"
                    title="A negative difference between actual and  target (estimate) values is favourable">Negative
                    variance
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
        </form>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <div class="action-buttons">
    <button class="btn-save" (click)="save()">Save</button>
    <button class="btn-close" (click)="close()">Close</button>
  </div>
</div>
